import Cookie from 'js-cookie';

export const FEATURES = { UI_INSURANCE_2: 'ui-insurance-2.0' };
const FEATURES_LIST = Object.values(FEATURES);

class FeatureFlags {
  /** @private */
  key = '__feature-flags__';

  /** @private */
  _setCookie(cookies) {
    Cookie.set(this.key, cookies, { expires: 30 });
  }

  /** @private */
  _toJSON() {
    const state = Cookie.getJSON(this.key) ?? {};

    return FEATURES_LIST.reduce((acc, feature) => {
      return { ...acc, [feature]: state[feature] ?? false };
    }, {});
  }

  disable(feature) {
    this._setCookie({ ...this.toJSON(), [feature]: false });
  }

  disabled(feature) {
    return this._toJSON()[feature] ?? true;
  }

  enable(feature) {
    this._setCookie({ ...this.toJSON(), [feature]: true });
  }

  enabled(feature) {
    return this._toJSON()[feature] ?? false;
  }
}

export const featureFlags = new FeatureFlags();
